import { Link } from 'react-router-dom';
import { getProductImageScale } from '../../../utils/productImagePresentation';
import { useCart } from '../../../context/CartContext';
import { useLanguage } from '../../../context/LanguageContext';

function ProductCard({ product }) {
  const cart = useCart();
  const { language, t, translate } = useLanguage();
  const formLabels = { capsules: translate('Capsules'), syrup: translate('Syrup'), oil: translate('Herbal Oil') };
  const productImage = product.productImage?.src ? product.productImage : null;
  const title = (product.translations?.[language]?.name || product.displayName || product.name).replace(/\s+capsules?$/i, '');

  return (
    <article className="catalogue-card">
      <Link aria-label={`View ${title} ${formLabels[product.form]}`} className="catalogue-card__image-link" to={`/products/${product.slug}`}>
        {productImage ? (
          <span
            className="catalogue-card__image-stage"
            style={{ '--catalogue-image-scale': getProductImageScale(product.slug) }}
          >
            <img alt={productImage.alt} className="catalogue-card__image" height="6720" loading="lazy" src={productImage.src} width="4480" />
          </span>
        ) : (
          <span className="catalogue-card__image-placeholder" role="img" aria-label={`Product image unavailable for ${title}`}>
            <span aria-hidden="true">SGH</span>
            <small>Product image unavailable</small>
          </span>
        )}
      </Link>
      <div className="catalogue-card__body">
        <p className="catalogue-card__form">{formLabels[product.form]}</p>
        <h2><Link to={`/products/${product.slug}`}>{title}</Link></h2>
        <p className="catalogue-card__pack">{translate('Pack size')}: {product.packSize.display}</p>
        <div className="catalogue-card__footer"><strong>{product.offerPrice != null ? <>₹{product.offerPrice} <s>₹{product.mrp.amount}</s></> : <>MRP {'\u20B9'}{product.mrp.amount}</>}</strong><Link className="button button--secondary" to={`/products/${product.slug}`}>{t('common.viewProduct')}</Link></div>
        {product.status === 'published' && product.active !== false && product.stockStatus === 'in_stock' ? <button className="button button--primary catalogue-card__cart" onClick={() => cart.add({ ...product, displayName: title })} type="button">{t('common.addToCart')}</button> : <p className="catalogue-card__availability">{translate('Currently unavailable for online purchase')}</p>}
      </div>
    </article>
  );
}

export default ProductCard;
